import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {RadioButton, Table} from "@wfp/ui";
import {KVPair, ListPage, SchoolMeal, Sortable} from "../../models/types";
import {dateParse, datetimeParse} from "../../hooks/formats";
import {TablePagination} from "../commons/table-pagination/table-pagination";
import {StatusBadge} from "../commons/status-badge";

interface Props {
    hidePagination?: boolean;
    page: ListPage<SchoolMeal>;
    loadPage: (page: number, pageSize?: number, filtering?: KVPair[], sorting?: string[]) => void;
    onSelectedSchoolMeal?: (id: number) => void;
    onClick: (id: number) => void;
    sort?: (field: string) => void;
    sortInfo?: Sortable[];
}

const headerGroups = ["id", "state", "delivery_date", 'last_modified'];

export function SchoolMealTable(props: Props) {
    const {t} = useTranslation();
    const [sortables, setSortables] = useState<Sortable[]>();


    useEffect(() => {
        if (!!props.sortInfo) {
            const sorts = headerGroups.map((header) => {
                const sort = props.sortInfo?.find((sort) => sort.code === header);
                return !!sort ? sort : {code: header, field: header, mode: 0, enabled: false}
            });
            setSortables(sorts);
        }
    }, [props.sortInfo]);

    function handleSorting(idx: number) {
        if (!!sortables && !!props.sort) {
            const sortable = sortables[idx];
            if (!sortable.enabled) {
                return;
            }
            sortable.mode = (sortable.mode + 1) % 3;
            setSortables([...sortables]);
            const value = sortable.mode === 1 ? `+${sortable.field}` : sortable.mode === 2 ? `-${sortable.field}` : sortable.field;
            props.sort(value);
        }
    }

    return (
        <div>
            <Table>
                <thead>
                <tr className="item-row-head">
                    {!!props.onSelectedSchoolMeal && (
                        <th></th>
                    )}
                    {headerGroups.map((header, idx) => (
                        <th key={idx} onClick={() => handleSorting(idx)}
                            className={props.sort && sortables?.at(idx)?.enabled ? "cursor-pointer" : ""}>
                            {t(header)}
                            {!!sortables?.length && (
                                <span className="ml-0.5">
                                {sortables[idx].mode === 2 ? '\u25bc' : sortables[idx].mode === 0 ? '\u2000' : '\u25b2'}
                            </span>
                            )}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {props.page.results.map((item: SchoolMeal) => (
                    <tr className="item-row cursor-pointer" key={item.id}>
                        {!!props.onSelectedSchoolMeal && (
                            <td>
                                <RadioButton labelText={''} name='row-select' value={item.id}
                                             onClick={() => !!props.onSelectedSchoolMeal ? props.onSelectedSchoolMeal(item.id) : {}}></RadioButton>
                            </td>
                        )}
                        <td className="item-col text-start" onClick={() => props.onClick(item.id)}>
                            {item.id}
                        </td>
                        <td className="item-col text-start p-0.5" onClick={() => props.onClick(item.id)}>
                            <StatusBadge status={item.state} />
                        </td>
                        <td className="item-col text-start" onClick={() => props.onClick(item.id)}>
                            {dateParse(item.deliveryDate)}
                        </td>
                        <td className="item-col text-start" onClick={() => props.onClick(item.id)}>
                            {!!item.updatedOn ? datetimeParse(item.updatedOn) : ''}
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            {!props.hidePagination && (
                <TablePagination page={props.page} loadPage={props.loadPage}/>
            )}
        </div>
    )
}
